import { useMutation, useQuery } from "@tanstack/react-query";
import {
  generateKYCLink,
  getKycIds,
  getKYCResults,
  sendKycEmail,
} from "../api/kyc";

export function useGenerateKycLink() {
  return useMutation({
    mutationFn: generateKYCLink,
  });
}

export function useFetchKYCResults() {
  return useMutation({
    mutationFn: getKYCResults,
  });
}

export function useSendKycEmail() {
  return useMutation({
    mutationFn: sendKycEmail,
  });
}

export function useKycIds(
  investmentAccountId: string,
  enabled: boolean = true
) {
  return useQuery({
    queryKey: ["kyc-ids", { investmentAccountId }],
    queryFn: () => getKycIds(investmentAccountId),
    enabled: enabled && !!investmentAccountId,
  });
}
